import { snapshot } from 'valtio';
import {
  FilterElements,
  FilterTypeSearch,
} from '../../common/filters-utils/filters-utils';
import {
  AppPages,
  navigate,
  navigateWithFilters,
} from '../../common/routing/app-navigator';
import { loadPipelineSummary } from '../actions/pipeline-summary-actions';
import { loadFilters } from '../actions/pipeline-summary-filters-actions';
import { FilterPipelineSummaryType } from '../pipeline-summary-types';
import PipelineSummaryFiltersStore from './pipeline-summary-filters-store';

export const setTotalPipelineSummaryFilters = (totalFilters: number) => {
  PipelineSummaryFiltersStore.totalFiltered = totalFilters;
};

export const clearFilters = () => {
  PipelineSummaryFiltersStore.filterBy = {};
  PipelineSummaryFiltersStore.numberOfFilters = 0;
  navigate(AppPages.PipelineSummary);
  loadPipelineSummary({ update: true });
  loadFilters();
};

export const clearFilter = (type: string) => {
  PipelineSummaryFiltersStore.filterBy[type] = [];
  navigateWithFilters(
    AppPages.PipelineSummary,
    snapshot(PipelineSummaryFiltersStore.filterBy),
  );
  loadPipelineSummary({ update: true });
  loadFilters();
};

export const setPipelineSummaryFilters = (
  pipelineSummaryFilters: FilterPipelineSummaryType,
) => {
  PipelineSummaryFiltersStore.pipelineSummaryFiltersType =
    pipelineSummaryFilters;
};

export const setPipelineSummaryFilterTypeSearch = (
  pipelineSummaryFiltersTypeSearch: FilterPipelineSummaryType,
): void => {
  const { searchValues } = snapshot(PipelineSummaryFiltersStore);

  PipelineSummaryFiltersStore.pipelineSummaryFiltersTypeSearch = Object.keys(
    pipelineSummaryFiltersTypeSearch,
  ).reduce((acc, key) => {
    acc[key] = searchValues[key]
      ? pipelineSummaryFiltersTypeSearch[key].filter((f: FilterElements) =>
          f.label.toLocaleLowerCase().includes(searchValues[key].toLowerCase()),
        )
      : pipelineSummaryFiltersTypeSearch[key];
    return acc;
  }, {} as FilterPipelineSummaryType);
};

export const handleSearchFilterType = (
  searchInput: string,
  filterType: string,
) => {
  const { pipelineSummaryFiltersType } = snapshot(PipelineSummaryFiltersStore);
  if (pipelineSummaryFiltersType && filterType) {
    const newFilteredTypes = pipelineSummaryFiltersType[filterType].filter(
      (pipelineFilterType: FilterElements) =>
        pipelineFilterType.label
          .toLocaleLowerCase()
          .includes(searchInput.toLowerCase()),
    );
    setSearchValue(filterType, searchInput);
    setPipelineSummaryFilterTypeSearch({
      ...pipelineSummaryFiltersType,
      [FilterTypeSearch[filterType]]: newFilteredTypes,
    });
  }
};

const setSearchValue = (filterType: string, searchInput: string) => {
  PipelineSummaryFiltersStore.searchValues[filterType] = searchInput;
};
